<template>
  <div id = "app">
    <main>
      <header>
        <h1 id = "title">
          スケジュール
        </h1>
        <p id = "description">
          created using the jikan.moe <i>unofficial</i> myanimelist REST API. 
          <br>
          these are all the series scheduled to broadcast today ({{this.currentDay}}).
        </p>
      </header>

      <hr>

      <div class = "container">
        <div v-for = "series in currentSchedule" :key = "series.title">
          <ScheduledSeries :schedule = "series"></ScheduledSeries>
        </div>
      </div>

      <footer>
        made with love & vuejs
        <br>
        <a href = "http://gore.rip">gore.rip</a>
      </footer>
    </main>
  </div>
</template>

<script>
import ScheduledSeries from './components/ScheduledSeries.vue'
import './main.scss'

const jikanjs  = require('jikanjs');
let schedule;

export default {
  name: 'app',
  components: {
    ScheduledSeries
  },
  data: function(){
    return {
      currentDay: '',
      currentSchedule: [],
      getSchedule: []
      }
  },
  created(){
    this.getCurrentDay();
    this.schedule(this.currentDay);
  },
  methods: {
    getCurrentDay: function(){
      let date = new Date();
      let weekdays = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday']

      this.currentDay = weekdays[date.getDay()]
    },
    schedule: function(day){
      this.getSchedule = jikanjs.loadSchedule(day).then(
        (response) => {
          response[day].forEach(element => {
            this.currentSchedule.push(
              {
                title: element.title,
                synopsis: element.synopsis,
                rating: element.score,
                link: element.url
              }
            )
            console.log(this.currentSchedule)
          });
        }
      ).catch((err) => {
        console.error(err);
      });
    }
  }
}
</script>